<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useTheme } from 'mcf-shared/composables/useTheme';

const { setMode } = useTheme();

onMounted(() => {
  setMode('light');
});
</script>